// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4400":"f7004aa6618d2969","5114":"61d9fe99af8b2fa6"}[chunkId] + ".js";
};